export const getRunningMode = () =>
  window.location.hostname === "localhost" ? "development" : "production";
